import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "sensitive-container"
};
const _hoisted_2 = {
  class: "assets-name"
};
const _hoisted_3 = {
  class: "sensitive-words"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.sensWordsList && $props.sensWordsList.length > 0 && $props.sensWordsList[0].sensitiveWords ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_cache[0] || (_cache[0] = _createElementVNode("div", {
    class: "sensitive-header"
  }, "涉及敏感词汇:", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.sensWordsList, sw => {
    return _openBlock(), _createElementBlock("div", {
      class: "sensitive-item",
      key: sw.assetsId
    }, [_createElementVNode("div", _hoisted_2, _toDisplayString(sw.assetsName) + ":", 1), _createElementVNode("div", _hoisted_3, _toDisplayString(sw.sensitiveWords), 1)]);
  }), 128))])) : _createCommentVNode("", true);
}